import {Box, Stack, Typography} from '@mui/material';
import React from 'react';

import {AlertInfo} from 'presentation/components';
import {CopySectionMaskEnum} from 'presentation/constants';
import {useContractStatus} from 'presentation/hooks';
import {translations} from 'presentation/translations-new';

import {HelpPageTaggingEnum} from 'main/analytics/gaTagsEnum';
import {CHANNELS_CONTACTS} from 'presentation/pages/private/help/constants/channelsContacts';
import {ChannelAccordion} from 'presentation/pages/private/help/components/ContactChannels/components/ChannelAccordion';
import {ChannelPhone} from 'presentation/pages/private/help/components/ContactChannels/components/ChannelPhone';
import {ChannelRegion} from 'presentation/pages/private/help/components/ContactChannels/components/ChannelRegion';
import {FinancialSupportAccordion} from 'presentation/pages/private/help/components/ContactChannels/components/FinancialSupportAccordion';
import {OmbudsmanFormLink} from 'presentation/pages/private/help/components/ContactChannels/components/OmbudsmanFormLink';
import {ContactChannelsBrandProps} from 'presentation/pages/private/help/components/ContactChannels/types';

const {callCenter, SAC, ombudsman} = translations['pt-br'].privateFlow.help.channels.ndiSaoPaulo;
const {title, financialSupport} = translations['pt-br'].privateFlow.help.channels.notredameSaude;

export function NotredameContactChannels({
	expandedState,
	handleAccordionToggle,
}: ContactChannelsBrandProps) {
	const {isValid} = useContractStatus();
	return (
		<Stack gap={1}>
			<Typography variant="subheader">{title}</Typography>
			<Box>
				{isValid ? (
					<ChannelAccordion
						dataTagId={HelpPageTaggingEnum.CLICK_EXPANDIR_TELEFONE_CALL_CENTER_AJUDA}
						title={callCenter.title}
						handleAccordionToggle={handleAccordionToggle}
						expandedState={expandedState}>
						<Stack gap={2}>
							<AlertInfo.Root>{callCenter.alert}</AlertInfo.Root>
							<ChannelRegion label={callCenter.capitalAndRegions}>
								<ChannelPhone
									value={CHANNELS_CONTACTS.NOTREDAME_SAUDE.CALL_CENTER.phone1}
									mask={CopySectionMaskEnum.PHONE_WITHOUT_DDD}
								/>
							</ChannelRegion>
							<ChannelRegion label={callCenter.otherRegions}>
								<ChannelPhone
									value={CHANNELS_CONTACTS.NOTREDAME_SAUDE.CALL_CENTER.phone2}
								/>
							</ChannelRegion>
							<ChannelRegion label={callCenter.infinity}>
								<ChannelPhone
									value={CHANNELS_CONTACTS.NOTREDAME_SAUDE.CALL_CENTER.infinity}
								/>
							</ChannelRegion>
							<Stack gap={1}>
								<Stack flexDirection="row" alignItems="end" gap="4px">
									<Typography variant="body1" color="primary">
										{callCenter.tpda}{' '}
										<Typography
											component="span"
											variant="helperText"
											lineHeight={1}
											color="primary">
											{callCenter.tpdaInfo}
										</Typography>
									</Typography>
								</Stack>
								<ChannelPhone
									value={CHANNELS_CONTACTS.NOTREDAME_SAUDE.CALL_CENTER.tpda}
								/>
							</Stack>
						</Stack>
					</ChannelAccordion>
				) : null}

				<ChannelAccordion
					dataTagId={HelpPageTaggingEnum.CLICK_EXPANDIR_TELEFONE_SAC_AJUDA}
					title={SAC.title}
					handleAccordionToggle={handleAccordionToggle}
					expandedState={expandedState}>
					<Stack gap={1}>
						<AlertInfo.Root>{SAC.alert}</AlertInfo.Root>
						<ChannelPhone value={CHANNELS_CONTACTS.NOTREDAME_SAUDE.SAC.phone1} />
					</Stack>
				</ChannelAccordion>
				<ChannelAccordion
					dataTagId={HelpPageTaggingEnum.CLICK_EXPANDIR_TELEFONE_OUVIDORIA_AJUDA}
					title={ombudsman.title}
					handleAccordionToggle={handleAccordionToggle}
					expandedState={expandedState}>
					<OmbudsmanFormLink
						label={ombudsman.form}
						buttonText={ombudsman.formButton}
						url={CHANNELS_CONTACTS.NOTREDAME_SAUDE.OMBUDSMAN.formUrl}
					/>
				</ChannelAccordion>
				<FinancialSupportAccordion
					title={financialSupport.title}
					expandedState={expandedState}
					handleAccordionToggle={handleAccordionToggle}
					phone={CHANNELS_CONTACTS.NOTREDAME_SAUDE.FINANCIAL_SUPPORT}
				/>
			</Box>
		</Stack>
	);
}
